import { Text, TextProps } from '@chakra-ui/react';

interface IOwnProps extends TextProps {
  children?: string;
}

const MessageError: React.FC<IOwnProps> = ({ children, ...rest }) => {
  return (
    <Text {...rest} mt={1} fontSize="0.78rem" textAlign="left" color="#E53E3E">
      {children}
    </Text>
  );
};

export default MessageError;
